import { render, staticRenderFns } from "./CreateTransaction.vue?vue&type=template&id=24338327&scoped=true"
import script from "./CreateTransaction.vue?vue&type=script&lang=js"
export * from "./CreateTransaction.vue?vue&type=script&lang=js"
import style0 from "./CreateTransaction.vue?vue&type=style&index=0&id=24338327&prod&scoped=true&lang=css"
import style1 from "./CreateTransaction.vue?vue&type=style&index=1&id=24338327&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24338327",
  null
  
)

export default component.exports